import { useContext } from "react";
import { AzureEntraContext } from "~/modules/auth/azureEntraContext";

export const useAuthContext = () => {
  const context = useContext(AzureEntraContext);
  if (!context) {
    throw new Error(
      "useAuthContext must be used within an AzureEntraContextProvider",
    );
  }
  return context;
};
